module.exports = __webpack_public_path__ + "assets/img/DS-room2 (1).02f0f718.jpg";